import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowDown, ArrowUpRight } from "lucide-react";
import { BlueprintGrid } from "../../components/BlueprintGrid";
import { fadeUp, viewportOnce } from "../../lib/motion";
import { trackEvent } from "../../lib/seo";
import { PRO_INTRO } from "../../lib/pro";

const HERO_IMAGE =
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1800&auto=format&fit=crop";

const ProHero = () => (
    <section
        data-testid="pro-hero-section"
        className="relative overflow-hidden bg-pro-navy pt-[128px] lg:pt-[168px]"
    >
        <BlueprintGrid />
        <div className="relative z-10 mx-auto grid max-w-[1600px] items-center gap-14 px-6 pb-20 md:px-10 lg:grid-cols-12 lg:gap-16 lg:px-16 lg:pb-28">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                animate="show"
                className="lg:col-span-7"
            >
                <div className="flex flex-wrap items-center gap-4">
                    <p className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-pro-steel-light">
                        <span className="h-1.5 w-1.5 bg-accent" />
                        BUILDEASE PRO
                    </p>
                    <span className="border border-pro-steel/60 bg-pro-blue/40 px-3 py-1.5 font-mono text-[13px] tracking-[0.22em] text-pro-platinum">
                        PROFESSIONAL PROGRAMME — EARLY ACCESS
                    </span>
                </div>
                <h1
                    data-testid="pro-hero-headline"
                    className="mt-8 max-w-3xl font-display text-4xl font-semibold leading-[1.08] text-pro-platinum md:text-6xl"
                >
                    Intelligence for the people building the future
                    <span className="text-accent">.</span>
                </h1>
                <p className="mt-6 max-w-2xl text-[16px] leading-relaxed text-pro-steel-light md:text-lg">
                    {PRO_INTRO.copy}
                </p>
                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <a
                        href="#pro-ecosystem"
                        data-testid="pro-hero-primary"
                        onClick={() =>
                            trackEvent("pro_pathway_click", "pro_hero_primary")
                        }
                        className="group inline-flex items-center gap-2 bg-accent px-7 py-4 text-[16px] font-semibold text-white transition-colors duration-300 hover:bg-[#ff7026]"
                    >
                        Explore BuildEase Pro
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </a>
                    <a
                        href="#pro-enquiry"
                        data-testid="pro-hero-secondary"
                        onClick={() =>
                            trackEvent("pro_pathway_click", "pro_hero_network")
                        }
                        className="group inline-flex items-center gap-2 border border-pro-steel px-7 py-4 text-[16px] font-medium text-pro-platinum transition-colors duration-300 hover:border-accent"
                    >
                        Join the Professional Network
                        <ArrowDown className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
                    </a>
                </div>
            </motion.div>

            <motion.figure
                variants={fadeUp}
                initial="hidden"
                animate="show"
                className="group relative overflow-hidden lg:col-span-5"
            >
                <img
                    src={HERO_IMAGE}
                    alt="Modern glass and steel office towers photographed from below at dusk"
                    loading="eager"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
                <figcaption className="absolute bottom-0 left-0 bg-pro-navy/85 px-4 py-2 font-mono text-[13px] tracking-[0.22em] text-pro-steel-light backdrop-blur-sm">
                    BUILT-ENVIRONMENT INTELLIGENCE — IN DEVELOPMENT
                </figcaption>
            </motion.figure>
        </div>
    </section>
);

export default ProHero;
